import angular from 'angular';
import nabValidator from './validatorService';
import ValidatorRules from './validatorRulesService';

const moduleName = angular
  .module('nabValidation', [])
  .factory('ValidatorRules', ValidatorRules)
  .service('nabValidator', nabValidator)
  .name;

export default moduleName;
